/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import "./left-sidebar.scss";

import React, { useState } from "react";
import { RefinementList, HierarchicalMenu } from "react-instantsearch-dom";
import { includes, map, sortBy } from "lodash";
import classnames from "classnames";

let activeFilterToggleOff;

const body = document.getElementsByTagName("body");
// toggle any open filters closed if clicked outside filters list
body[0].addEventListener("click", function (e) {
  const inFiltersList = e.target.closest(".filters-list");

  if (!inFiltersList) {
    activeFilterToggleOff();
  }
});

const editMode = window.HIFI_APP.HIFI_EDIT_MODE;

const filters = {
  genre: {
    tax: "genre",
    label: "Genre",
  },
  instrument: {
    tax: "primary-instrument",
    label: "Main Instrument",
  },
  keyword: {
    tax: "keyword",
    label: "Keywords",
  },
  artist: {
    tax: "artist",
    label: "Artists",
  },
};

if (editMode) {
  filters.status = {
    tax: "status",
    label: "Status",
  };
}

function FilterItems({ filterKey, filter }) {
  if ("genre" === filterKey) {
    return (
      <HierarchicalMenu attributes={["genre.lvl0", "genre.lvl1"]} limit={50} />
    );
  }

  return (
    <RefinementList
      attribute={filter.tax}
      limit={50}
      operator="and"
      transformItems={(items) => sortBy(items, [(i) => i.label])}
    />
  );
}

function Filter({ filterKey, filter, activeFilter, activeFilterToggle }) {
  return (
    <li
      key={filterKey}
      className={classnames({
        filter: true,
        [`filter-${filterKey}`]: true,
        active: filterKey === activeFilter,
      })}
    >
      <span
        className="filter-label"
        title={filter.title ? filter.title : filter.label}
        onClick={(e) => {
          e.persist();
          setTimeout(() => {
            if (includes(e.target.classList, "filter-label")) {
              activeFilterToggle(filterKey);
            }
          }, 50);
        }}
      >
        {filter.label}
      </span>
      <FilterItems filter={filter} filterKey={filterKey} />
    </li>
  );
}

/**
 * Tracks Area.
 *
 * @param root0
 * @param root0.filterItems
 */
function LeftSidebar() {
  const [activeFilter, setActiveFilter] = useState("");
  const activeFilterToggle = (newValue) =>
    newValue === activeFilter ? setActiveFilter("") : setActiveFilter(newValue);

  activeFilterToggleOff = () => activeFilter && activeFilterToggle("");

  const filterRows = map(filters, (filter, filterKey) => (
    <Filter
      key={filterKey}
      filter={filter}
      filterKey={filterKey}
      activeFilterToggle={activeFilterToggle}
      activeFilter={activeFilter}
    />
  ));

  return (
    <div className="left-sidebar">
      <div>
        <ul className="filters-list">{filterRows}</ul>
      </div>
    </div>
  );
}

export default LeftSidebar;
